module.exports = __webpack_public_path__ + "components/signup-page/static/snow-forecast_outside--header_logo-6b5f9a11ea23f1436378d9ede168e0f9.webp";